import { Component, inject, OnInit, signal } from '@angular/core';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';
import { AdPreview } from '../ad-preview/ad-preview';
import { SelectCreative } from '../select-creative/select-creative';

@Component({
  selector: 'cad-ad-details',
  imports: [AdPreview, SelectCreative],
  templateUrl: './ad-details.html',
  styleUrl: './ad-details.css',
})
export class AdDetails implements OnInit {

  expanded = signal<boolean>(true);
  destinationExpanded = signal<boolean>(false);

  public createSparkCampaignService = inject(CreateSparkCampaign);

  ngOnInit(): void {
    this.createSparkCampaignService.loadCTAStandard();
  }

  isCallToActionActive(): boolean {
    return this.createSparkCampaignService.call_to_action_active();
  }

  onCallToActionActiveInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    this.createSparkCampaignService.call_to_action_active.set(!!input?.checked);
  }

  onAdTextInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const raw = input?.value ?? '';
    const next = raw.slice(0, 100);
    if (input && input.value !== next) {
      input.value = next;
    }
    const trimmed = next.trim();
    this.createSparkCampaignService.ad_text.set(trimmed ? trimmed : undefined);
  }

  onLandingPageUrlInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const value = input?.value?.trim();
    this.createSparkCampaignService.landing_page_url.set(value ? value : undefined);
  }

  truncatedLandingPageUrl(max = 40): string {
    const value = this.createSparkCampaignService.landing_page_url()?.trim();
    if (!value) {
      return 'Set Destination URL';
    }
    if (value.length <= max) {
      return value;
    }
    return `${value.slice(0, max - 1)}…`;
  }

  isDisclaimerEnabled(): boolean {
    return this.createSparkCampaignService.enable_disclaimer();
  }

  onEnableDisclaimerInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const enabled = !!input?.checked;
    this.createSparkCampaignService.enable_disclaimer.set(enabled);
    if (enabled) {
      this.createSparkCampaignService.disclaimer_type.set('TEXT_ONLY');
    } else {
      this.createSparkCampaignService.disclaimer_type.set(undefined);
      // this.createSparkCampaignService.disclaimer_text.set(undefined);
    }
  }

  onDisclaimerTextInput(event: Event): void {
    const input = event.target as HTMLTextAreaElement | null;
    const raw = input?.value ?? '';
    const next = raw.slice(0, 90);
    if (input && input.value !== next) {
      input.value = next;
    }
    const trimmed = next.trim();
    this.createSparkCampaignService.disclaimer_text.set(trimmed ? trimmed : undefined);
  }

  getVideoDuration(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds}`;
  }
}
